export class NativeStreamSamplingFeature {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "expr",
            "baseName": "expr",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamSamplingFeature.attributeTypeMap;
    }
    constructor() {
    }
}
